import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { StaticBox, LinkedInput, Modal } from 'components/basic'
import { notify, date } from 'helpers'
import http from 'API/http'

class TicketEditor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ticket: null,
      access: null,
      contactInfo: '',
      editable: false,
      loading: false
    }
  }

  componentDidMount () {
    this.setState({ticket: this.props.ticket})
  }

  componentWillReceiveProps (props) {
    if (props.lastUpdated === this.props.lastUpdated) return false
    this.setState({ticket: props.ticket})
  }

  async getContactInfo () {
    var [err, res] = await http.get('2.4/tickets/' + this.state.ticket.coTicketReference + '/contactinfo')
    if (err) return notify.warn('Unable to fetch contact info')
    this.setState({contactInfo: res.data.contactInfo || '', contactModal: true})
  }

  async updateContactInfo () {
    var [err, res] = await http.put('2.4/tickets/' + this.state.ticket.coTicketReference + '/contactinfo', {
      contactInfo: this.state.contactInfo
    })
    if (err) {
      this.setState({contactModal: false})
      return notify.warn(res.data.cause)
    }
    this.setState({contactInfo: res.data.contactInfo || '', contactModal: false})
    notify.success('Contact info updated')
  }

  async closeTicket () {
    this.setState({closing: true})
    var [err, res] = await http.put('2.4/tickets/' + this.state.ticket.coTicketReference, {
      comment: null,
      status: 'CLOSED'
    })
    if (err) {
      notify.warn(res.cause)
      return this.setState({closing: false})
    }
    this.setState({closing: false, ticket: {...this.state.ticket, status: 'CLOSED'}})
    notify.success('The ticket has been closed')
    this.props.callback()
  }
  async reOpen () {
    this.setState({opening: true})
    var [err, res] = await http.put('2.4/tickets/' + this.state.ticket.coTicketReference, {
      status: (this.state.ticket.responsible === 'SP' ? 'IN_PROGRESS_SP' : 'IN_PROGRESS_CO')
    })
    if (err) {
      notify.warn(res.cause)
      return this.setState({opening: false})
    }
    this.setState({opening: false, ticket: {...this.state.ticket, status: (this.state.ticket.responsible === 'SP' ? 'IN_PROGRESS_SP' : 'IN_PROGRESS_CO')}})
    notify.success('The ticket has been reopened')
    this.props.callback()
  }

  async updateTicket () {
    var [err, res] = await http.put('2.4/tickets/' + this.state.ticket.coTicketReference, {
      comment: null,
      responsible: this.state.ticket.responsible,
      status: this.state.ticket.status,
      priority: this.state.ticket.priority
    })

    if (err) return notify.alert(res.cause)
    notify.success('Your changes has been saved')
    this.setState({editable: false})
    this.props.callback()
  }

  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }

  render () {
    if (!this.state.ticket) return false
    return (
      <div>
        <StaticBox
          cols={12}
          icon='home'
          title={`${!this.state.ticket.access.streetName ? (this.state.ticket.heading + ' - ' + this.state.ticket.coTicketReference) : ''} ${this.state.ticket.access.streetName || ''} ${this.state.ticket.access.streetNumber || ''} ${this.state.ticket.access.mduApartmentNumber || ''} ${this.state.ticket.access.mduDistinguisher || ''}`}
          buttons={[
            { icon: 'fa-edit', event: () => this.setState({editable: true}), hidden: (this.state.editable || this.state.ticket.status === 'CLOSED') },
            { icon: 'fa-save', event: () => this.updateTicket(), hidden: !this.state.editable }
          ]}
          >
          <div className='row'>
            <div className='col-md-3'>
              <label>Title</label>
              <LinkedInput context={this} path='ticket.heading' editable={false} />
            </div>
            <div className='col-md-3'>
              <label>Status</label>
              <Select
                value={this.state.ticket.status}
                onChange={e => this.setState({ticket: {...this.state.ticket, status: e.value, responsible: (e.value === 'IN_PROGRESS_CO' ? 'CO' : e.value === 'IN_PROGRESS_SP' ? 'SP' : this.state.ticket.responsible)}})}
                options={[
                  {
                    name: 'CREATED',
                    value: 'CREATED'
                  },
                  {
                    name: 'IN_PROGRESS_CO',
                    value: 'IN_PROGRESS_CO'
                  },
                  {
                    name: 'IN_PROGRESS_SP',
                    value: 'IN_PROGRESS_SP'
                  },
                  {
                    name: 'CLOSED',
                    value: 'CLOSED'
                  }
                ]}
                valueKey='value'
                labelKey='name'
                disabled={!this.state.editable}
                clearable={false}
              />
            </div>
            <div className='col-md-3'>
              <label>Priority</label>
              <Select
                value={this.state.ticket.priority}
                onChange={e => this.setState({ticket: {...this.state.ticket, priority: e.value}})}
                options={[
                  {
                    name: 'None',
                    value: 'None'
                  },
                  {
                    name: 'Minor',
                    value: 'Minor'
                  },
                  {
                    name: 'Medium',
                    value: 'Medium'
                  },
                  {
                    name: 'Major',
                    value: 'Major'
                  },
                  {
                    name: 'Critical',
                    value: 'Critical'
                  }
                ]}
                valueKey='value'
                labelKey='name'
                disabled={!this.state.editable}
                clearable={false}
              />
            </div>
            <div className='col-md-3'>
              <label>Problem Type</label>
              <LinkedInput context={this} editable={false} path='ticket.problemType' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-3'>
              <label>Access ID</label>
              <LinkedInput context={this} editable={false} path='ticket.access.accessId' />
            </div>
            <div className='col-md-3'>
              <label>Responsible</label>
              <Select
                value={this.state.ticket.responsible}
                onChange={e => this.setState({ticket: {...this.state.ticket, responsible: e.value, status: (e.value === 'SP' ? 'IN_PROGRESS_SP' : 'IN_PROGRESS_CO')}})}
                options={[
                  {
                    name: 'CO',
                    value: 'CO'
                  },
                  {
                    name: 'SP',
                    value: 'SP'
                  }
                ]}
                valueKey='value'
                labelKey='name'
                disabled={!this.state.editable}
                clearable={false}
              />
            </div>
            <div className='col-md-3 form-group'>
              <label>Contact Info</label>
              <div className='input-group'>
                <input type='text' className='form-control' value={'Click button to view info'} disabled />
                <span className='input-group-btn'>
                  <button className='btn btn-primary' type='button'
                    onClick={() => this.getContactInfo()}><i className='fa fa-eye' />
                  </button>
                </span>
              </div>
            </div>
            <div className='col-md-3'>
              <label>MAC-Address</label>
              <LinkedInput context={this} path='ticket.additionalInfo.mac' editable={false} />
            </div>
          </div>
          <div className="row">
            <div className='col-md-3'>
              <label>Your Internal Reference</label>
              <LinkedInput context={this} path='ticket.spReference' editable={false} />
            </div>
            <div className='col-md-3'>
              <label>Your Internal Ticket Reference</label>
              <LinkedInput context={this} path='ticket.spTicketReference' editable={false} />
            </div>
            <div className='col-md-3'>
              <label>CO Ticket Reference</label>
              <LinkedInput context={this} path='ticket.coTicketReference' editable={false} />
            </div>
            </div>
            <div className="row">
            <div className='col-md-3'>
              <label>IP-Address</label>
              <LinkedInput context={this} path='ticket.additionalInfo.ip' editable={false} />
            </div>
            <div className='col-md-3'>
              <label>Link</label>
              <input type='text' value={(this.state.ticket.additionalInfo.link === null ? 'UNKNOWN' : (this.state.ticket.additionalInfo.link ? 'LINK IS UP' : 'LINK IS DOWN'))} disabled className='form-control' />
            </div>
          </div>
          <div className='row'>
            <hr />
            <div className='col-md-3'>
              <label>Created by</label>
              <LinkedInput context={this} path='ticket.createdBy' editable={false} />
            </div>
            <div className='col-md-3'>
              <label>Created at</label>
              <input type='text' value={date.utc(this.state.ticket.createdAt)} disabled className='form-control' />
            </div>
            <div className='col-md-3'>
              <label>Updated at</label>
              <input type='text' value={date.utc(this.state.ticket.updatedAt)} disabled className='form-control' />
            </div>
          </div>
          <hr />
          <div className='row'>
            <div className='col-md-12 text-right'>
              {this.state.ticket.status === 'CLOSED' && <a disabled={this.state.opening} onClick={e => this.reOpen()} className='btn btn-primary'><i className={'fa fa-fw ' + (this.state.opening ? 'fa-circle-o-notch fa-spin' : 'fa-eye')} /> Re-open Ticket</a> }
              {this.state.ticket.status !== 'CLOSED' && <a disabled={this.state.closing} onClick={e => this.closeTicket()} className='btn btn-danger'><i className={'fa fa-fw ' + (this.state.closing ? 'fa-circle-o-notch fa-spin' : 'fa-archive')} /> Close Ticket</a> }
            </div>
          </div>
        </StaticBox>
        <Modal title={'Contact Info'} isOpen={this.state.contactModal} close={() => this.setState({contactModal: false})} buttons={[
          { text: 'Close', event: () => this.setState({contactModal: false}) },
          { text: 'Save', event: () => this.updateContactInfo(), hidden: !this.state.contactEdit },
          { text: 'Edit', event: () => this.setState({contactEdit: true}), hidden: this.state.contactEdit }
        ]}>
          <div className='content-wrapper'>
            <textarea className='form-control' maxLength='10000' style={{height: '150px'}} onChange={e => this.setState({contactInfo: e.target.value})} value={this.state.contactInfo} readOnly={!this.state.contactEdit} />
          </div>
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketEditor = connect(state => state.siteReducer)(TicketEditor)
export default TicketEditor



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/ticket/TicketEditor.js